import { render, staticRenderFns } from "./AdditionalDataTabs.vue?vue&type=template&id=6a0b2785&scoped=true&"
import script from "./AdditionalDataTabs.vue?vue&type=script&setup=true&lang=js&"
export * from "./AdditionalDataTabs.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AdditionalDataTabs.vue?vue&type=style&index=0&id=6a0b2785&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a0b2785",
  null
  
)

export default component.exports